import { LinearProgress } from "@material-ui/core"
import PropTypes from "prop-types"
import { useContext, useEffect } from "react"
import { useQuery } from "react-query"
import { getCourse } from "~/actions/courses"
import resourcesColor from "~/assets/Icons/colored-glasses.svg"
import analyticsColor from "~/assets/Icons/colored-pie-chart.svg"
import settingsColor from "~/assets/Icons/colored-settings.svg"
import coloredTranslations from "~/assets/Icons/colored-translations.svg"
import coloredUser from "~/assets/Icons/colored-user.svg"
import contentColor from "~/assets/Icons/colored-video.svg"
import analytics from "~/assets/Icons/feather-pie-chart.svg"
import content from "~/assets/Icons/feather-video.svg"
import resources from "~/assets/Icons/noun_Glasses_1182135.svg"
import seoColor from "~/assets/Icons/seo-colored-icon.svg"
import seo from "~/assets/Icons/seo-icon.svg"
import settings from "~/assets/Icons/settings.svg"
import translations from "~/assets/Icons/translations.svg"
import user from "~/assets/Icons/user.svg"
import Box from "~/components/Common/Box"
import ContentTabs from "~/components/Common/ContentTabs"
import CourseHeader from "~/components/courses/CourseHeader"
import UnsavedChanges from "~/components/courses/UnsavedChanges"
import AppContext from "~/contexts/App"
import { CourseContainer } from "~/contexts/Course"
import Page from "~/pages/Page"
import Router from "~/router"
import useStyles from "./styles"

const Course = ({ routes = [], ...rest }) => {
  const classes = useStyles()

  const { authUser } = useContext(AppContext)

  const courseId = +rest?.match?.params?.course_id
  const {
    data: course,
    isLoading: courseLoading,
    refetch: refetchCourse,
  } = useQuery(["course", courseId], () => getCourse(courseId), {
    cacheTime: 0,
  })

  useEffect(() => {
    refetchCourse()
  }, [])

  //declares tabs to map over in content tabs component
  const tabsWithTest = [
    {
      label: "Course Content",
      link: `/courses/${courseId}`,
      icon1: content,
      icon2: contentColor,
    },
    {
      label: "Settings",
      link: `/courses/${courseId}/settings`,
      icon1: settings,
      icon2: settingsColor,
    },
    {
      label: "Seo",
      link: `/courses/${courseId}/seo`,
      icon1: seo,
      icon2: seoColor,
    },
    {
      label: "Resources",
      link: `/courses/${courseId}/resources`,
      icon1: resources,
      icon2: resourcesColor,
    },
    {
      label: "Analytics",
      link: `/courses/${courseId}/analytics`,
      icon1: analytics,
      icon2: analyticsColor,
    },
    {
      label: "Test Users",
      link: `/courses/${courseId}/testUsers`,
      icon1: user,
      icon2: coloredUser,
    },
    {
      label: "Translations",
      link: `/courses/${courseId}/translations`,
      icon1: translations,
      icon2: coloredTranslations,
    },
  ]

  const tabsWithOutTest = [
    {
      label: "Course Content",
      link: `/courses/${courseId}`,
      icon1: content,
      icon2: contentColor,
    },
    {
      label: "Settings",
      link: `/courses/${courseId}/settings`,
      icon1: settings,
      icon2: settingsColor,
    },
    {
      label: "Seo",
      link: `/courses/${courseId}/seo`,
      icon1: seo,
      icon2: seoColor,
    },
    {
      label: "Resources",
      link: `/courses/${courseId}/resources`,
      icon1: resources,
      icon2: resourcesColor,
    },
    {
      label: "Analytics",
      link: `/courses/${courseId}/analytics`,
      icon1: analytics,
      icon2: analyticsColor,
    },
    {
      label: "Translations",
      link: `/courses/${courseId}/translations`,
      icon1: translations,
      icon2: coloredTranslations,
    },
  ]

  //Logic to define whether a course is a draft
  let draft = "true"
  let tabs = null

  if (
    course?.published === 0 &&
    course?.has_been_published === 0 &&
    course?.archived === 0
  ) {
    draft = true
  } else {
    draft = false
  }

  //Logic to display Test User and Analytics tabs under courses
  if (draft === true || authUser.id === 1) {
    tabs = tabsWithTest
  } else {
    tabs = tabsWithOutTest
  }

  if (courseLoading) {
    return <LinearProgress />
  }

  return (
    <Page>
      <CourseContainer course={course} courseLoading={courseLoading}>
        <Box display="flex" flexDirection="column" height="100%" width="100%">
          <Box flexShrink={0} flexGrow={0} width="100%">
            <CourseHeader courseId={courseId} />
            <ContentTabs tabs={tabs} />
          </Box>
          <Box flexGrow={1} overflow="auto">
            <Router routes={routes} {...rest} />
          </Box>
        </Box>
        <UnsavedChanges />
      </CourseContainer>
    </Page>
  )
}

Course.propTypes = {
  routes: PropTypes.array,
}

export default Course
